import React from 'react';
import { useCtx, useRecurso, api } from '../estado.jsx';
import { Wave } from './Comunes.jsx';

export function Sidebar() {
  const { session, view, sedeId, go, logout } = useCtx();
  const esAleph = session.rol === 'aleph';

  // Aleph necesita la lista de sedes para navegar. Una sede solo la suya, y
  // ya viene en la misma llamada, así que no hay dos peticiones distintas.
  const sedes = useRecurso(() => api.sedes(), []);
  const propia = !esAleph && sedes.datos ? sedes.datos[0] : null;

  const item = (v, label, sid, extra = '') => {
    const vistaNormalizada = view === 'editsede' ? 'sede' : view;
    const activo = vistaNormalizada === v && (sedeId || null) === (sid || null);
    return (
      <button key={v + (sid || '')} className={'nav-item ' + extra + (activo ? ' on' : '')}
              onClick={() => go(v, sid)}>
        {extra.includes('global') || extra.includes('new') ? null : <span className="dot" />}
        {label}
      </button>
    );
  };

  return (
    <aside className="side">
      <div className="side-brand"><div className="wordmark">TUNE</div><Wave cls="wave" /></div>

      <div className="userchip">
        {esAleph ? (
          <><div className="role">Aleph · Global</div>
            <div className="who">Todas las sedes</div>
            <div className="mail">{session.mail}</div></>
        ) : (
          <><div className="role">Sede · Operador</div>
            <div className="who">{propia ? propia.comuna : '…'}</div>
            <div className="mail">{session.mail}</div></>
        )}
      </div>

      <div>
        {esAleph ? (
          <>
            {item('global', 'Aleph · Global', null, 'global')}
            {item('clientesglobal', 'Clientes', null)}
            <div className="nav-label">Sedes</div>
            {sedes.cargando ? <div className="nav-label">cargando…</div> : null}
            {(sedes.datos || []).map((x) => item('sede', '· ' + x.comuna, x.id))}
            {item('alta', '＋ Nueva sede', null, 'new')}
            {item('accesos', 'Accesos', null)}
            {item('codigos', 'Códigos', null)}
          </>
        ) : (
          <>
            <div className="nav-label">{propia ? propia.comuna : ''}</div>
            {item('sede', 'Tablero', session.sedeId)}
            {item('validar', 'Validar pase', session.sedeId)}
            {item('clientes', 'Clientes', session.sedeId)}
            {item('manage', 'Mi sede', session.sedeId)}
          </>
        )}
      </div>

      <div className="side-foot">
        <button className="logout" onClick={logout}>‹ Cerrar sesión</button>
      </div>
    </aside>
  );
}
